/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect } from 'react';
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import secureLocalStorage from 'react-secure-storage';
const Stripe = ({ Amount }) => {

    const { BaseUrl, setPaymentLoading } = useContext(MyContext);

    const handlePayment = async () => {
        const UserData = secureLocalStorage.getItem("Logindata");
        if (UserData) {
            const UserDetails = JSON.parse(UserData);
            await axios.post(`${BaseUrl}react_stripe`,
                {
                    "amt": Amount,
                    "name": UserDetails.name,
                    "email": UserDetails.email,
                })
                .then((res) => {
                    if (res.data.Result === "true") {
                        window.location.href = res.data.payment_url;
                    } else {
                        showToast({ title: res.data.ResponseMsg, id: "error" });
                    }
                    setPaymentLoading(false);
                })
                .catch((error) => {
                    console.error("react_stripe", error);
                });
        }
    };

    useEffect(() => {
        if (!Amount) return;
        handlePayment();
        setPaymentLoading(true);
    }, [Amount]);

    return null;
}

export default Stripe;
/* jshint ignore:end */